/* --------------------------------------------------------------------------------------
   storage.const.js
   Copyright © 2023 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/
export const sessionVar = {
    appStarted: "appStarted",
    deviceUrl: "deviceUrl",
    communityString: "communityString",
    apiKey: "apiKey",
    hylandServerUrl: "serverUrl",
    hylandLicense: "license",
    hylandDatasource: "data",
    sessionId: "sessionId",
    username: "username",
    macAddress: "macAddress",
}

export const localVar = {
    appGallerySettings: "appGallerySettings",
    userScanSettings: "userScanSettings",
    configurationSettings: "configurationSettings",
    loginstate: "loginstate"
}